var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tooltip',{style:(("width: " + _vm.width)),attrs:{"content":_vm.content,"disabled":!_vm.permissao,"className":"notificao"}},[(_vm.isVisible)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }